import React, { useMemo } from 'react'

import clsx from 'clsx'

import { TextField } from '@mui/material'

import { IMask, IMaskInput } from 'react-imask'

export const timeSpentMaskOptions = {
  mask: '0 d HH h MM m',
  blocks: {
    HH: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 23
    },
    MM: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 59
    }
  },
  placeholderChar: '0'
}

// eslint-disable-next-line babel/new-cap
const MaskedInput = React.forwardRef(({ onChange, ...props }, inputRef) => (
  <IMaskInput
    {...timeSpentMaskOptions}
    {...props}
    overwrite
    inputRef={inputRef}
    lazy={false}
    onAccept={onChange}
  />
))

const MaskedTextField = React.forwardRef(({ classes, disabled, assignee, ...props }, ref) => (
  <TextField
    {...props}
    ref={ref}
    disabled={disabled}
    InputProps={useMemo(() => ({
      className: clsx([classes.timeSpentField, disabled && classes.inputHidden]),
      inputComponent: MaskedInput,
    }), [classes, disabled])}
    inputProps={{ 'data-testid': `${assignee.membership}-time-spent` }}
  />
))

export default MaskedTextField
